// source: search/search.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
goog.exportSymbol('proto.search.SearchOptions', null, global);
goog.exportSymbol('proto.search.SearchRequest', null, global);
goog.exportSymbol('proto.search.SearchResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.search.SearchOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.search.SearchOptions.repeatedFields_, null);
};
goog.inherits(proto.search.SearchOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.search.SearchOptions.displayName = 'proto.search.SearchOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.search.SearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.search.SearchRequest.repeatedFields_, null);
};
goog.inherits(proto.search.SearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.search.SearchRequest.displayName = 'proto.search.SearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.search.SearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.search.SearchResponse.repeatedFields_, null);
};
goog.inherits(proto.search.SearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.search.SearchResponse.displayName = 'proto.search.SearchResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.search.SearchOptions.repeatedFields_ = [2,3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.search.SearchOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.search.SearchOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.search.SearchOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.search.SearchOptions.toObject = function(includeInstance, msg) {
  var f, obj = {
    exactMatchStrsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    includeAllStrsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    includeSomeStrsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    excludedStrsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.search.SearchOptions}
 */
proto.search.SearchOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.search.SearchOptions;
  return proto.search.SearchOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.search.SearchOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.search.SearchOptions}
 */
proto.search.SearchOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addExactMatchStrs(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addIncludeAllStrs(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addIncludeSomeStrs(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addExcludedStrs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.search.SearchOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.search.SearchOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.search.SearchOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.search.SearchOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExactMatchStrsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getIncludeAllStrsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getIncludeSomeStrsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getExcludedStrsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * repeated string exact_match_strs = 2;
 * @return {!Array<string>}
 */
proto.search.SearchOptions.prototype.getExactMatchStrsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.search.SearchOptions} returns this
 */
proto.search.SearchOptions.prototype.setExactMatchStrsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.search.SearchOptions} returns this
 */
proto.search.SearchOptions.prototype.addExactMatchStrs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.search.SearchOptions} returns this
 */
proto.search.SearchOptions.prototype.clearExactMatchStrsList = function() {
  return this.setExactMatchStrsList([]);
};


/**
 * repeated string include_all_strs = 3;
 * @return {!Array<string>}
 */
proto.search.SearchOptions.prototype.getIncludeAllStrsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.search.SearchOptions} returns this
 */
proto.search.SearchOptions.prototype.setIncludeAllStrsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.search.SearchOptions} returns this
 */
proto.search.SearchOptions.prototype.addIncludeAllStrs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.search.SearchOptions} returns this
 */
proto.search.SearchOptions.prototype.clearIncludeAllStrsList = function() {
  return this.setIncludeAllStrsList([]);
};


/**
 * repeated string include_some_strs = 4;
 * @return {!Array<string>}
 */
proto.search.SearchOptions.prototype.getIncludeSomeStrsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.search.SearchOptions} returns this
 */
proto.search.SearchOptions.prototype.setIncludeSomeStrsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.search.SearchOptions} returns this
 */
proto.search.SearchOptions.prototype.addIncludeSomeStrs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.search.SearchOptions} returns this
 */
proto.search.SearchOptions.prototype.clearIncludeSomeStrsList = function() {
  return this.setIncludeSomeStrsList([]);
};


/**
 * repeated string excluded_strs = 5;
 * @return {!Array<string>}
 */
proto.search.SearchOptions.prototype.getExcludedStrsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.search.SearchOptions} returns this
 */
proto.search.SearchOptions.prototype.setExcludedStrsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.search.SearchOptions} returns this
 */
proto.search.SearchOptions.prototype.addExcludedStrs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.search.SearchOptions} returns this
 */
proto.search.SearchOptions.prototype.clearExcludedStrsList = function() {
  return this.setExcludedStrsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.search.SearchRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.search.SearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.search.SearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.search.SearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.search.SearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    searchOptions: (f = msg.getSearchOptions()) && proto.search.SearchOptions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.search.SearchRequest}
 */
proto.search.SearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.search.SearchRequest;
  return proto.search.SearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.search.SearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.search.SearchRequest}
 */
proto.search.SearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addContentIds(value);
      break;
    case 2:
      var value = new proto.search.SearchOptions;
      reader.readMessage(value,proto.search.SearchOptions.deserializeBinaryFromReader);
      msg.setSearchOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.search.SearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.search.SearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.search.SearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.search.SearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getSearchOptions();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.search.SearchOptions.serializeBinaryToWriter
    );
  }
};


/**
 * repeated string content_ids = 1;
 * @return {!Array<string>}
 */
proto.search.SearchRequest.prototype.getContentIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.search.SearchRequest} returns this
 */
proto.search.SearchRequest.prototype.setContentIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.search.SearchRequest} returns this
 */
proto.search.SearchRequest.prototype.addContentIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.search.SearchRequest} returns this
 */
proto.search.SearchRequest.prototype.clearContentIdsList = function() {
  return this.setContentIdsList([]);
};


/**
 * optional SearchOptions search_options = 2;
 * @return {?proto.search.SearchOptions}
 */
proto.search.SearchRequest.prototype.getSearchOptions = function() {
  return /** @type{?proto.search.SearchOptions} */ (
    jspb.Message.getWrapperField(this, proto.search.SearchOptions, 2));
};


/**
 * @param {?proto.search.SearchOptions|undefined} value
 * @return {!proto.search.SearchRequest} returns this
*/
proto.search.SearchRequest.prototype.setSearchOptions = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.search.SearchRequest} returns this
 */
proto.search.SearchRequest.prototype.clearSearchOptions = function() {
  return this.setSearchOptions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.search.SearchRequest.prototype.hasSearchOptions = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.search.SearchResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.search.SearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.search.SearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.search.SearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.search.SearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    includedContentIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    excludedContentIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.search.SearchResponse}
 */
proto.search.SearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.search.SearchResponse;
  return proto.search.SearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.search.SearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.search.SearchResponse}
 */
proto.search.SearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIncludedContentIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addExcludedContentIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.search.SearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.search.SearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.search.SearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.search.SearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncludedContentIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getExcludedContentIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string included_content_ids = 1;
 * @return {!Array<string>}
 */
proto.search.SearchResponse.prototype.getIncludedContentIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.search.SearchResponse} returns this
 */
proto.search.SearchResponse.prototype.setIncludedContentIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.search.SearchResponse} returns this
 */
proto.search.SearchResponse.prototype.addIncludedContentIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.search.SearchResponse} returns this
 */
proto.search.SearchResponse.prototype.clearIncludedContentIdsList = function() {
  return this.setIncludedContentIdsList([]);
};


/**
 * repeated string excluded_content_ids = 2;
 * @return {!Array<string>}
 */
proto.search.SearchResponse.prototype.getExcludedContentIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.search.SearchResponse} returns this
 */
proto.search.SearchResponse.prototype.setExcludedContentIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.search.SearchResponse} returns this
 */
proto.search.SearchResponse.prototype.addExcludedContentIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.search.SearchResponse} returns this
 */
proto.search.SearchResponse.prototype.clearExcludedContentIdsList = function() {
  return this.setExcludedContentIdsList([]);
};


goog.object.extend(exports, proto.search);
